import styled from 'styled-components';
          
import PerfectScrollbar from 'react-perfect-scrollbar';

export const Container = styled.div``;
export const Main = styled.div``;
export const InfoDay = styled.div``;
export const DayList = styled.ul``;
export const DayItem = styled.li``;
export const Scroll = styled(PerfectScrollbar)``;
export const ScrollSmall = styled(PerfectScrollbar)``;
export const ScrollMsg = styled(PerfectScrollbar)``;
